import { render, staticRenderFns } from "./RegisterInfo.vue?vue&type=template&id=f56bdd82&scoped=true"
import script from "./RegisterInfo.vue?vue&type=script&lang=js"
export * from "./RegisterInfo.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfo.vue?vue&type=style&index=0&id=f56bdd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56bdd82",
  null
  
)

export default component.exports